import { Observable } from "@zebrabi/observable";
import { setOfficeSettings, getOfficeSettings } from "@zebrabi/office-settings";

export const CHART_CHOOSER_STORE = "ChartChooserStore";

type StoreData = {
    isVisible: boolean;
    selectedDimension: string;
    selectedChart: string;
    areComments: boolean;
};

class Store {
    static data;
    static initialData = {
        isVisible: true,
        selectedDimension: "time",
        selectedChart: "",
        areComments: true,
    };

    constructor() {
        const officeData = getOfficeSettings(CHART_CHOOSER_STORE);
        if (Store.data && !officeData) return;
        Store.data = new Observable<StoreData>(officeData || Store.initialData);
    }

    static get() {
        return Store.data.get();
    }

    static set(value: Partial<StoreData>) {
        const nextValue = {
            ...Store.data.get(),
            ...value,
        };
        Store.data.set(nextValue);
        setOfficeSettings(CHART_CHOOSER_STORE, nextValue);
    }

    static subscribe(handler: (value: StoreData) => void) {
        Store.data.subscribe(handler);
    }

    static unsubscribe() {
        Store.data.unsubscribe();
    }
}

export type { StoreData as ChartChooserStoreData };
export { Store as ChartChooserStore };
